import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function SandboxField(props) {
    return (
        <FormikInput
            type={'checkbox'}
            name={'additionalData.sandbox'}
            label={'shippingMethods.form.field.additionalData.sandbox.label'}
            noPadding={true}
        />
    )
}

export default SandboxField;
